import React from 'react';

const TableOfContents = ({ tableOfContents }) => {
	return (
		<div className="c-md-toc">
			<ul>
				{tableOfContents.items.map((heading, i) => {
					return (
						<li key={i}>
							<a href={heading.url}>{heading.title}</a>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default TableOfContents;
